/**
 * Deep link for "Supplier quote uploaded" bells → Project Hub Suppliers tab.
 */

export function buildSupplierRfqNotificationPath(args: {
  hubProjectId?: string | null;
  submissionId?: string | null;
}): string | null {
  const projectId = (args.hubProjectId || '').trim();
  if (!projectId) return null;
  const q = new URLSearchParams();
  q.set('tab', 'suppliers');
  const submissionId = (args.submissionId || '').trim();
  if (submissionId) q.set('submission', submissionId);
  return `/project-hub/${encodeURIComponent(projectId)}?${q.toString()}`;
}

/** Prefer contracted hub project, then any non-preconstruction, then first match. */
export function pickHubProjectIdForDeal(
  projects: Array<{ id?: string; phase?: string }>,
): string | null {
  const withId = projects.filter((p) => (p.id || '').trim());
  if (!withId.length) return null;
  const contracted = withId.find((p) => p.phase === 'contracted');
  if (contracted?.id) return contracted.id.trim();
  const active = withId.find((p) => p.phase !== 'preconstruction');
  if (active?.id) return active.id.trim();
  return withId[0].id!.trim();
}
